<template>
    <div class="container">
        <img class="container-bg-style" :src="Images.img_page_bg2" alt="">
        <div class="content-item-wrap amount-info-wrap">
            <div class="amount-info-item">
                <div class="value">
                    <span class="unit mr-1">¥</span>
                    <span class="text">{{amount}}</span>
                </div>
                <div class="title">
                    <span>当前可提现金额</span>
                    <span v-if="account_type == Constants.ACCOUNT_SHOP && formData.trade_company_name">（{{formData.trade_company_name}}）</span>
                </div>
            </div>
        </div>
        <div class="content-item-wrap apply-form-wrap">
            <div class="form-input-wrap">
                <div class="form-item-wrap" v-if="account_type == Constants.ACCOUNT_SHOP">
                    <van-field v-model="formData.trade_company_name" readonly @click="showWalletList = true" label="提现钱包" placeholder="请选择" input-align="right" />
                </div>
                <div class="normal" :class="{'form-type-wrap': account_type == Constants.ACCOUNT_SHOP}">
                    <div class="form-item-wrap">
                        <van-field v-model="formData.amount" label="提现金额" placeholder="请输入" input-align="right" />
                    </div>
                </div>
                <div class="form-type-wrap" v-if="type == Constants.WITHDRAW_PUBLIC || type == Constants.WITHDRAW_INDIVIDUAL_PUBLIC">
                    <div class="form-item-wrap">
                        <van-field v-model="formData.bank_account" label="开户名（公司名）" placeholder="请输入" input-align="right" />
                    </div>
                    <div class="form-item-wrap">
                        <van-field v-model="formData.bank_name" label="开户行" placeholder="请输入" input-align="right" />
                    </div>
                    <div class="form-item-wrap">
                        <van-field v-model="formData.bank_card_no" label="银行账号" placeholder="请输入" input-align="right" />
                    </div>
                </div>
                <div class="form-type-wrap" v-if="type == Constants.WITHDRAW_NO_PUBLIC">
                    <div class="form-item-wrap">
                        <van-field v-model="formData.merchant_name" label="商户名称" placeholder="请输入" input-align="right" />
                    </div>
                    <div class="form-item-wrap">
                        <van-field v-model="formData.duty_paragraph" label="商户号税号" placeholder="请输入" input-align="right" />
                    </div>
                    <div class="form-item-wrap">
                        <van-field v-model="formData.bank_card_no" label="银行卡号" placeholder="请输入" input-align="right" />
                    </div>
                    <div class="form-item-wrap">
                        <van-field v-model="formData.bank_account" label="持卡人姓名" placeholder="请输入" input-align="right" />
                    </div>
                </div>
                <div class="form-type-wrap" v-if="type == Constants.WITHDRAW_ALIPAY">
                    <div class="form-item-wrap">
                        <van-field v-model="formData.alipay_account" label="支付宝账号" placeholder="请输入" input-align="right" />
                    </div>
                    <div class="form-item-wrap">
                        <van-field v-model="formData.alipay_name" label="支付宝姓名" placeholder="请输入" input-align="right" />
                    </div>
                </div>
                <div class="form-type-wrap" v-if="type == Constants.WITHDRAW_BANK">
                    <div class="form-item-wrap">
                        <van-field v-model="formData.bank_name" label="开户行" placeholder="请输入" input-align="right" />
                    </div>
                    <div class="form-item-wrap">
                        <van-field v-model="formData.bank_account" label="开户人姓名" placeholder="请输入" input-align="right" />
                    </div>
                    <div class="form-item-wrap">
                        <van-field v-model="formData.bank_card_no" label="银行卡号" placeholder="请输入" input-align="right" />
                    </div>
                </div>
                <div class="form-type-wrap" v-if="type == Constants.WITHDRAW_WECHAT">
                    <div class="form-item-wrap">
                        <van-field name="wechat_image" label="微信收款码">
                            <template #input>
                                <van-uploader v-model="wechat_image" :max-size="uploaderMaxSize.imageMaxSize * 1024" @oversize="_onOversize" :max-count="1" :after-read="_afterReadPhoto" />
                            </template>
                        </van-field>
                    </div>
                </div>
            </div>
            <div class="form-btn-wrap btn-wrap mt-5">
                <van-button class="btn-item submit-btn-item" round block type="info" native-type="submit" @click="onPressSubmit">立即提现</van-button>
            </div>
        </div>
        <van-action-sheet title="商城钱包" cancel-text="取消" close-on-click-action v-model="showWalletList" :actions="wallet_shop_list" @cancel="onCancelShowWalletList" @select="onSelectShowWalletList" />
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import WithdrawRecordItem from '../../components/item/WithdrawRecordItem';
import {
    QiniuUpload
} from '@/utils/qiniuUpload'
export default {
    components: {
        WithdrawRecordItem
    },
    computed: {
        ...mapGetters(["userInfo"]),
        navArray() {
            if (this.user_type == this.Constants.USER_MASTER) {
                return this.masterNavArray;
            }
            return this.agentNavArray;
        }
    },
    data() {
        return {
            loading: false,
            showWalletList: false,
            amount: this.$route.query.amount || 0,
            type: this.$route.query.type || this.Constants.WITHDRAW_PUBLIC,
            account_type: this.$route.query.account_type || this.Constants.ACCOUNT_CLASS,
            user_type: this.$route.query.user_type || this.Constants.USER_MASTER,
            qiniuInfo: {},
            uploaderMaxSize: {},
            wechat_image: [],
            wallet_shop_list: [],
            formData: {
                // 提现金额
                amount: '',
                // 开户名(公司名)
                bank_account: '',
                // 开户行(银行名)
                bank_name: '',
                // 银行卡号
                bank_card_no: '',
                // 商户名称
                merchant_name: '',
                // 商户号税号
                duty_paragraph: '',
                // 微信收款码
                wechat_image: '',
                // 支付宝账号
                alipay_account: '',
                // 支付宝姓名
                alipay_name: '',
                // 提现类型 subject课程提现   shop商城提现
                account_type: '',
                // 结算公司ID
                trade_company_id: '',
                // 结算公司名称
                trade_company_name: '',
            },
        }
    },
    mounted() {
        this.getQiniuData();
        if (this.account_type == this.Constants.ACCOUNT_SHOP) {
            this.getWalletShopList();
        }
    },
    methods: {
        _onBack() {
            this.$router.back();
        },

        // 点击跳转
        _onPressToNavigate(pageTitle, path, query) {
            if (pageTitle) {
                query = {
                    ...query,
                    pageTitle,
                }
            }
            this.$router.push({
                path,
                query
            });
        },

        _onPressToWeb(url) {
            if (!url) return;
            window.location.href = url;
        },

        // 获取七牛云配置
        async getQiniuData() {
            let url = this.API.qiniuToken;
            let params = {};
            let result = await this.$post(url, params);
            this.qiniuInfo = result;
            this.uploaderMaxSize = result.uploaderMaxSize;
        },

        // 获取七牛云配置
        async getWalletShopList() {
            let url = this.API.wallet_shop_list;
            let params = {};
            let result = await this.$post(url, params);
            this.wallet_shop_list = result.data;
            console.log('result---->', result);
        },

        onCancelShowWalletList() {
            this.showWalletList = false;
        },

        onSelectShowWalletList(action, index) {
            console.log('action, index---->', action, index);
            this.formData = {
                ...this.formData,
                trade_company_id: action.trade_company_id,
                trade_company_name: action.trade_company_name,
            };
            this.amount = action.amount;
        },

        _onOversize(file) {
            console.log('file---->', file);
            this.ToastManager('图片大小不能超过：' + (this.uploaderMaxSize.imageMaxSize / 1024) + 'M');
        },

        _afterReadPhoto(file) {
            console.log('file---->', file);
            if (this.IMAGES_DRIVER == this.Constants.DRIVER_QINIUKODO) {
                QiniuUpload(this.qiniuInfo, file)
                    .then((res) => {
                        console.log('res------------->', res)
                        this.Message({
                            message: "上传中",
                            type: 4,
                            time: 500,
                        });
                        let url = this.qiniuInfo.domain + res.key;
                        this.formData.wechat_image = url;
                    })
                    .catch((err) => {
                        console.log('err------------->', err)
                    });
            }
            if (this.IMAGES_DRIVER == this.Constants.DRIVER_ALIOSS) {
                this._onUploadImageToAliOss(file);
            }
            if (this.IMAGES_DRIVER == this.Constants.DRIVER_TENCENTCOS) {

            }
        },

        // 上传阿里云
        async _onUploadImageToAliOss(file) {
            let url = this.API.uploadToAliOss;
            let params = {
                file: file.file,
                uid: this.userInfo.id,
            };
            this.Message({
                message: "上传中",
                type: 4,
                time: 500,
            });
            let result = await this.$uploadFormData(url, params);
            if (result.code == this.GLOBAL.SUCCESS_CODE) {
                this.formData.wechat_image = result.url;
            }
        },

        async onPressSubmit() {
            let url = this.API.apply_cash_out;
            let data = {
                ...this.formData,
                type: this.type,
                account_type: this.account_type,
            };

            console.log('this.formData.amount, this.amount---->', this.formData.amount, this.amount);

            if (this.account_type == this.Constants.ACCOUNT_SHOP && !this.formData.trade_company_id) {
                return this.ToastManager('请先选择提现钱包');
            }

            if (!this.formData.amount) {
                return this.ToastManager('请输入提现金额');
            }

            if (this.formData.amount * 1 > this.amount) {
                console.log('1---->', 1);
                return this.ToastManager('可提现金额不足');
            }


            const result = await this.$post(url, data);
            this.ToastManager(result.msg);
            if (result.code === this.GLOBAL.SUCCESS_CODE) {

            }
        },

    },
}
</script>
<style lang="less" scoped>
.container {
    .container-bg-style {
        top: 0;
        z-index: 0;
        width: 100%;
        position: absolute;
    }

    .content-item-wrap {
        z-index: 1;
        position: relative;
        padding: 1rem 1.5rem;

        .content-title-wrap {
            margin-bottom: 2rem;

            .title-icon {
                width: 2.4rem;
                margin-right: 1rem;
            }

            .title {
                font-size: 1.5rem;
                font-weight: 600;
            }
        }
    }

    .amount-info-wrap {
        margin: 1.5rem 0 0;

        .amount-info-item {
            color: #fff;
            font-size: 1.4rem;
            text-align: center;

            .title {}

            .value {
                font-size: 2.4rem;
                margin-bottom: 1rem;
            }
        }

    }

    .apply-form-wrap {
        .form-input-wrap {
            overflow: hidden;
            background: #fff;
            border-radius: .5rem;

            .form-type-wrap {
                .form-item-wrap {
                    border-top: 1px dashed #eee;
                }
            }
        }

        .form-btn-wrap {
            .submit-btn-item {
                border: 0;
                border-radius: .5rem;
                background: linear-gradient(225deg, #9cb2f4, #6472e8);
            }
        }
    }

}
</style>